import { EntityModel } from '@/interfaces'
import {
  ALL_MAILCHIMP_CONFIGS_QUERY,
  CREATE_MAILCHIMP_CONFIG_MUTATION,
  DELETE_MAILCHIMP_CONFIG_MUTATION,
  FORCE_DELETE_MAILCHIMP_CONFIG_MUTATION,
  SINGLE_MAILCHIMP_CONFIG_QUERY,
  UPDATE_MAILCHIMP_CONFIG_MUTATION,
} from './graphql'

const mailchimpConfigModel: EntityModel = {
  name: 'mailchimpConfig',
  namePlural: 'mailchimpConfigs',
  uniqueName: 'mailchimpConfig',
  uniqueNamePlural: 'mailchimpConfigs',
  path: 'config/providers/newsletter/mailchimp_config',
  baseUrl: '/config/providers/newsletter/mailchimp_configs',
  translationPrefix: 'entities:mailchimpConfig.',
  getDisplayName: (values: any) => {
    return 'MAILCHIMP CONFIG'
  },
  gql: {
    getAll: ALL_MAILCHIMP_CONFIGS_QUERY,
    getSingle: SINGLE_MAILCHIMP_CONFIG_QUERY,
    create: CREATE_MAILCHIMP_CONFIG_MUTATION,
    update: UPDATE_MAILCHIMP_CONFIG_MUTATION,
    delete: DELETE_MAILCHIMP_CONFIG_MUTATION,
    forceDelete: FORCE_DELETE_MAILCHIMP_CONFIG_MUTATION,
  },
  attributes: {
    apiKey: {
      name: 'apiKey',
      label: 'entities:mailchimpConfig.attributes.apiKey.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'password',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    serverPrefix: {
      name: 'serverPrefix',
      label: 'entities:mailchimpConfig.attributes.serverPrefix.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    listId: {
      name: 'listId',
      label: 'entities:mailchimpConfig.attributes.listId.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
  },
}

export default mailchimpConfigModel
